import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { receiveMessage } from '../store/websocketSlice'
import { serverName } from '../variables'
export const useWebSocket = (cameraId?: number, isEnabled = true) => {
	const { userData } = useAppSelector(store => store.userReducer)
	const { apiToken } = useAppSelector(state => state.authReducer)
	const [socket, setSocket] = useState(null)
	const [latestMessage, setLatestMessage] = useState(null)
	const dispatch = useAppDispatch()
	const serverNameForWs = 'wss' + serverName.substring(serverName.indexOf(':'))

	useEffect(() => {
		if (userData.id && apiToken && !socket && isEnabled) {
			const path = cameraId
				? `ws/identification/${cameraId}`
				: `ws/${userData.id}`

			const ws = new WebSocket(`${serverNameForWs}${path}?token=${apiToken}`)

			ws.addEventListener('open', () => {
				console.log('Socket successfuly open')
			})

			ws.addEventListener('message', event => {
				const messageData = JSON.parse(event.data)
				dispatch(receiveMessage(messageData))
				setLatestMessage(messageData)
			})

			ws.addEventListener('close', () => {})

			setSocket(ws)
		}

		return () => {
			if (socket) {
				socket.close()
				setSocket(null)
			}
		}
	}, [dispatch, userData.id, apiToken, socket, serverNameForWs, cameraId])

	return { socket, latestMessage }
}
